export default (theme) => ({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    content: {
        width: '40%',
        height: '40%',
    },
    chartType: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: theme.colors.actionMinor[50],
        boxShadow:
            '0px 1px 3px 0px #273C5033, 0px 2px 2px 0px #273C501F, 0px 0px 2px 0px #273C5024',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,

        '@media (max-width: 1600px)': {
            width: '60px',
            height: '60px',
        },
    },
    chartTypeIcon: {
        width: '50%',
        height: '50%',
        '& svg': {
            width: '100%',
            height: '100%',
        },
    },
    line: {
        position: 'relative',
        width: '2px',
        height: '40px',
        backgroundColor: theme.colors.grey[100],

        '&::before': {
            content: '""',
            width: '6px',
            height: '6px',
            bottom: '-5px',
            left: '50%',
            transform: 'translateX(-50%)',
            borderRadius: '50%',
            border: `2px solid ${theme.colors.grey[100]}`,
            backgroundColor: theme.colors.primary.white,
            position: 'absolute',
        },

        '@media (max-width: 1600px)': {
            height: '34px',
        },
    },
    box: {
        minWidth: '250px',
        height: '62px',
        padding: '0 12px',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '8px',
        boxShadow:
            '0px 1px 3px 0px #273C5033, 0px 2px 2px 0px #273C501F, 0px 0px 2px 0px #273C5024',
        backgroundColor: theme.colors.primary.white,
        cursor: 'default',

        '&[class*="incomplete"]': {
            '& [class*="boxLeft"]': { backgroundColor: theme.colors.actionMinor[50] },
        },

        '@media (max-width: 1600px)': {
            height: '54px',
        },
    },
    incomplete: {},
    boxLeft: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.colors.semantic.infoCustom50,
        flexShrink: 0,

        '@media (max-width: 1600px)': {
            width: '34px',
            height: '34px',
        },
    },
    boxRight: {},
});
